import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface OverviewTabProps {
  currentTopic: any;
  topicLoading: boolean;
  sources: any[];
  sourcesLoading: boolean;
  agentMetrics: any[];
}

export const OverviewTab = ({
  currentTopic,
  topicLoading,
  sources,
  sourcesLoading,
  agentMetrics
}: OverviewTabProps) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardHeader>
            <CardTitle className="text-sm">Current Topic</CardTitle>
          </CardHeader>
          <CardContent>
            {topicLoading ? (
              "Loading..."
            ) : (
              <Badge>{currentTopic?.main_topic}</Badge>
            )}
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-sm">Active Sources</CardTitle>
          </CardHeader>
          <CardContent>
            {sourcesLoading ? (
              "Loading..."
            ) : (
              <Badge>{sources?.length || 0}</Badge>
            )}
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-sm">Agent Performance</CardTitle>
          </CardHeader>
          <CardContent>
            <Badge variant={agentMetrics?.length ? "default" : "secondary"}>
              {agentMetrics?.length ? "Active" : "Inactive"}
            </Badge>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};